export default __webpack_public_path__ + "static/media/close.2ec4c2a7.svg";